import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    payout_list: '/dashboard/v2/contracts/{contractId}/payouts/', // GET
    payout_statistics: '/dashboard/v2/contracts/{contractId}/payouts/statistics/', // GET
    payout_create: '/dashboard/v2/contracts/{contractId}/payouts/create-payout/', // POST - Crea nuovo payout
    payout_request: '/dashboard/v2/contracts/{contractId}/payouts/{id}/request-payout/', // PATCH - Richiede payout con fattura e IBAN
    payout_detail: '/dashboard/v2/contracts/{contractId}/payouts/{id}/', // GET
    payout_delete: '/dashboard/v2/contracts/{contractId}/payouts/{id}/delete-requested-payout/', // DELETE - Elimina payout requested
    payout_download_excel: '/dashboard/v2/contracts/{contractId}/payouts/{id}/download_excel/', // GET
    payout_service_excel: '/dashboard/v2/contracts/{contractId}/payouts/{id}/pica-service/{serviceId}/excel/', // GET
}

export default {
    async fetchPayoutList(contractId, filters, pagination, sorting) {
        const params = {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1
        }
        
        // Handle sorting
        if (sorting && sorting.column) {
            params.ordering = sorting.asc === false ? `-${sorting.column}` : sorting.column
        }
        
        const result = await client.get(endpoints.payout_list.replace('{contractId}', contractId), params)
        
        // Return data with correct pagination structure
        return {
            results: result.results || [],
            count: result.count || 0,
            next: result.next || null,
            previous: result.previous || null,
            pagination: {
                num_pages: Math.ceil((result.count || 0) / (pagination.page_size || 20)),
                page_size: pagination.page_size || 20,
                page: pagination.page || 1,
                total: result.count || 0,
            }
        }
    },
    
    async fetchPayoutStatistics(contractId) {
        const stats = await client.get(endpoints.payout_statistics.replace('{contractId}', contractId))
        
        // Transform the API response to match the expected structure
        return {
            total_amount_pending: stats.unrequested?.paid_net || "0.00",
            total_amount_requested: stats.requested?.paid_net || "0.00",
            total_amount_paid: stats.paid?.paid_net || "0.00",
            total_photos_sold: stats.media?.photos_sold || 0,
            total_orders: stats.media?.catalog_total || 0,
            average_payout_amount: stats.media?.average_price || "0.00",
            pending_payouts: stats.pica_services?.length || 0,
            requested_payouts: 0, // Count of payouts in requested status - needs backend
            paid_payouts: 0, // Count of payouts in paid status - needs backend
            total_payouts: stats.pica_services?.length || 0,
            last_payout_date: null, // Not in current API response
            next_payout_estimated: null, // Not in current API response
            // Keep original data for reference
            raw: stats
        }
    },
    
    async createPayout(contractId) {
        // Crea nuovo payout aggregando tutti gli ordini non pagati
        return await client.post(endpoints.payout_create.replace('{contractId}', contractId), {})
    },
    
    async requestPayout(contractId, payoutId, data) {
        // Richiede il pagamento fornendo fattura, IBAN e note. Cambia lo stato da pending a requested
        const formData = new FormData()
        
        formData.append('iban', data.iban)
        formData.append('invoice', data.invoice)
        if (data.save_iban !== undefined) {
            formData.append('save_iban', data.save_iban)
        }
        if (data.notes) {
            formData.append('notes', data.notes)
        }
        
        return await client.patch(
            endpoints.payout_request
                .replace('{contractId}', contractId)
                .replace('{id}', payoutId), 
            formData
        )
    },
    
    async deletePayout(contractId, payoutId) {
        // Elimina un payout in stato requested (solo se ha flag is_last_requested)
        return await client.delete(
            endpoints.payout_delete
                .replace('{contractId}', contractId)
                .replace('{id}', payoutId)
        )
    },
    
    async fetchPayoutDetail(contractId, id) {
        return await client.get(endpoints.payout_detail.replace('{contractId}', contractId).replace('{id}', id))
    },
    
    async downloadExcel(contractId, payoutId) {
        const url = endpoints.payout_download_excel
            .replace('{contractId}', contractId)
            .replace('{id}', payoutId)
        
        // Use client's download method - filename comes from server's content-disposition header
        await client.download(url)
    },
    
    async downloadServiceExcel(contractId, payoutId, serviceId) {
        const url = endpoints.payout_service_excel
            .replace('{contractId}', contractId)
            .replace('{id}', payoutId)
            .replace('{serviceId}', serviceId)
        
        // Use client's download method - filename comes from server's content-disposition header
        await client.download(url)
    }
}